var render, staticRenderFns
import script from "./DisputeComment.vue?vue&type=script&lang=js"
export * from "./DisputeComment.vue?vue&type=script&lang=js"
import style0 from "./DisputeComment.vue?vue&type=style&index=0&id=6568432e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6568432e",
  null
  
)

export default component.exports